import { Icon, Stack, Typography } from '@mui/material';
import { Attention2Icon, ErrorBlock } from '@schooly/style';
import { FC, PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

type ErrorEmailBlockProps = {
  textId: string;
  renderAction?: () => React.ReactNode;
} & PropsWithChildren;

export const ErrorEmailBlock: FC<ErrorEmailBlockProps> = ({ textId, renderAction, children }) => {
  const { formatMessage } = useIntl();

  return (
    <ErrorBlock gap={1}>
      <Stack direction="row" gap={2} alignItems="center" width="100%">
        <Icon sx={{ color: 'error.light', path: { color: 'error.main' } }}>
          <Attention2Icon />
        </Icon>

        <Stack direction="row" gap={1} justifyContent="space-between" width="100%">
          <Typography variant="h3" color="inherit" whiteSpace="pre-wrap">
            {formatMessage({ id: textId })}
          </Typography>

          {renderAction?.()}
        </Stack>
      </Stack>

      {children}
    </ErrorBlock>
  );
};
